import React, { useState } from "react";
import cn from "classnames";
import { joinWaitlist, getViewerEmail } from "./learnApi";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PERSONAS = [
  { id: "host", label: "Host" },
  { id: "creator", label: "Creator" },
  { id: "both", label: "Both" },
];

/**
 * "Notify me when Postaway Academy opens" — email + optional persona chips +
 * "I attended the 2026 Summit" (helps reconcile the attendee rate later).
 * `compact` drops the chips/checkbox for the hero variant.
 */
const NotifyForm = ({ compact = false, source = "academy_coming_soon", className }) => {
  const [email, setEmail] = useState(getViewerEmail());
  const [persona, setPersona] = useState("");
  const [attended, setAttended] = useState(false);
  const [state, setState] = useState("idle"); // idle | sending | done | error
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const clean = email.trim().toLowerCase();
    if (!EMAIL_REGEX.test(clean)) { setError("That email doesn't look right."); return; }
    setError("");
    setState("sending");
    try {
      await joinWaitlist({ email: clean, persona: persona || undefined, attended2026: attended, source });
      setState("done");
    } catch (_) {
      setState("error");
      setError("Something went wrong — please try again.");
    }
  };

  if (state === "done") {
    return (
      <div className={cn("learn-notify learn-notify--done", className)} role="status">
        <strong>You're on the list.</strong> We'll email {email.trim().toLowerCase()} the moment the first sessions go live.
      </div>
    );
  }

  return (
    <form className={cn("learn-notify", { "learn-notify--compact": compact }, className)} onSubmit={submit} noValidate>
      <div className="learn-notify__row">
        <input
          type="email"
          inputMode="email"
          autoComplete="email"
          className="learn-notify__input"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError(""); }}
          aria-label="Email address"
        />
        <button type="submit" className="learn-btn learn-btn--primary learn-notify__btn" disabled={state === "sending"}>
          {state === "sending" ? "Adding…" : "Notify me"}
        </button>
      </div>
      {!compact && (
        <div className="learn-notify__meta">
          <div className="learn-notify__chips" role="radiogroup" aria-label="I'm a">
            <span className="learn-notify__label">I'm a</span>
            {PERSONAS.map((p) => (
              <button
                key={p.id}
                type="button"
                role="radio"
                aria-checked={persona === p.id}
                className={cn("learn-chip learn-chip--small", { "learn-chip--active": persona === p.id })}
                onClick={() => setPersona(persona === p.id ? "" : p.id)}
              >
                {p.label}
              </button>
            ))}
          </div>
          <label className="learn-notify__check">
            <input type="checkbox" checked={attended} onChange={(e) => setAttended(e.target.checked)} />
            <span>I attended the 2026 Summit</span>
          </label>
        </div>
      )}
      {error && <div className="learn-field-error">{error}</div>}
    </form>
  );
};

export default NotifyForm;
